// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";

export const End = ({ size, stroke, fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill={fill || "none"}
      stroke={stroke}
      strokeWidth="2px"
    >
      <rect
        x="30.5"
        y=".8"
        width="16.3"
        height="46.2"
        transform="translate(77.3 47.9) rotate(180)"
      />
      <polygon points="1 46.4 30.1 23.9 1 1.4 1 46.4" />
    </svg>
  );
};
